(function() {

	'use strict';

	Object.toArray = function( obj ){
		return Object.keys(obj).map(function(uid){ return obj[uid]; });
	};
	Object.resolve = function(path, obj) {
		return path.split('.').reduce(function(prev, curr) {
			return prev ? prev[curr] : undefined
		}, obj || self)
	};

	angular.module("artestUserAssets", [ 'gettext' ])
	
	.config([ '$provide', function( $provide ) {

		$provide.decorator( '$q', [ '$delegate', function( $delegate ) {

			var $q = $delegate;

			$delegate.promiseQueueRunner = promiseQueueRunner;
			$delegate.allIterator = promiseIterator;
			
			return $delegate;

			/**
			 * [promiseIterator description]
			 * @param  {[type]} arr Array of functions that returns a promise
			 * @return {[type]}     Array of results of promises
			 */
			function promiseIterator( arr, interval ){

				if (typeof interval == "number") {
					arr = arr.map(function( prms ){
						return function() {
							return $q(function( resolve ) {
								setTimeout( resolve, interval );
							}).then(function() {
								return prms();
							});

							return $timeout( prms, interval );
						};
					});
				} else if (typeof interval != "undefined") throw new Error( "Invalid argument! interval must be typeof number" );

				var response = new Array( arr.length );
				for (var i = 0; i < arr.length; i++) response[i] = null;

				return $q.when( handle( 0 ));

				function handle( itr ){
					if( !arr[ itr ]) return response;
					return arr[ itr ]().then(function( result ){
						response[ itr ] = result;
						return handle( itr+1 );
					});
				}
			}

			function promiseQueueRunner( arr, interval ) {

				if (typeof interval == "number") {
					arr = arr.map(function( prms ){
						return function() {
							return $q(function( resolve ) {
								setTimeout( resolve, interval );
							}).then(function() {
								return prms();
							});
							return $timeout( prms, interval );
						};
					});
				} else if (typeof interval != "undefined") throw new Error( "Invalid argument! interval must be typeof number" );

				var defer = $q.defer();

				var done      = [];
				var errors    = [];
				var responses = [];
				var length    = arr.length;

				var result = angular.extend( defer.promise, {
					length:    length,
					errors:    errors,
					responses: responses,
					cancel:    cancel,
					restart:   restart
				});

				return restart();

				function handle() {

					var itr = 0;

					// Etsitään iterator'n arvo, jolle ei response'a ole asetettu
					for (; itr <= length; itr++) {

						if (itr == length) {
							// Ollaan ajettu kaikki läpi ja voidaan lopettaa
							
							result.state = "ready";

							defer.resolve( responses );

							return;

						} else if (!done[ itr ]) {
							break;
						}
					}

					// Ollaanhan yhä ajamassa?
					if (result.state == "running") {

						return $q.when( arr[ itr ]() ).catch(function( error ) {

							//console.error( error );

							errors[ itr ] = error;

							return error;

						}).then(function( result ) {

							done[ itr ] = true;

							responses[ itr ] = result;

							return handle();
						});
					}
				}

				function cancel() {

					result.state = "stopped";
				}

				function restart() {

					result.state = "running";

					handle();

					return result;
				}
			}
		}])
	}])

	.service( "$userAssets", [ "$rootScope", "$ApiHandler", "$q", "$timeout", "gettextCatalog", "$sce",function( $rootScope, $ApiHandler, $q, $timeout, gettextCatalog, $sce ) {

		var self = window.ArtestUserAssets = this;

		var assets = this.assets = {
			currencies         : [ ],
			currencies_data    : { },
			clients            : { },
			clients_lists      : { },
			clients_artists    : { },
			clients_oeuvres    : { },
			oeuvre_properties  : window.__ARTEST_OEUVRES_PROPERTIES || null,
			artest_users       : { },
			datamap            : null,
			datamap_horizontal : null,
			datamaps           : { }, // Tämän pitäisi sisältää lopulta kaikki datamap-assetsit
			attachments        : { },
			attahcments_data   : { }
		};

		this.MAX_IMAGE_UPLOAD_SIZE = 10000000; // 5M -> 10M 18.2.2022 -m

		try {

			var element = document.getElementById( "ArtestUserAssets-assets-presets" ), presets;

			if (element) {

				try {
					presets = JSON.parse( element.innerText );
				} catch (error) {

					console.error( error );

					presets = eval( '(function(){ return ' + element.innerText + ' })();' );
				}

				for (var key in presets) {

					if (assets[ key ]) {

						for (var skey in presets[ key ]) {

							if (!assets[ key ][ skey ]) {

								assets[ key ][ skey ] = presets[ key ][ skey ];
							}
						}
					}
				}
			}

		} catch (error) {
			console.error( error );
		}
		

		$rootScope.$on( "gettextLanguageChanged", function() {
			try {
				console.log( "$userAssets :: $on(gettextLanguageChanged) :: Refreshing oeuvre_properties titles" );
				for (var uid in assets.oeuvre_properties) {
					var prop = assets.oeuvre_properties[ uid ];
					if (prop instanceof OeuvreProperty) prop.title = prop.i18n_title = prop.$i18n_gen_title();

					if (prop.$path) {
						var parents = [];
						getParentsOf( uid, parents );
						prop.$path.title  = parents.reverse().map(function(item){
							return item.title + " > ";
						}).join( "" );
						prop.$path.title += prop.title;
					}
				}
			} catch( err ) { console.error( err ); }

			function getParentsOf( uid, parents ){
				var item = assets.oeuvre_properties[uid], puid = item.parent_method_uid;
				if (puid && assets.oeuvre_properties[ puid ]) {
					parents.push( assets.oeuvre_properties[ puid ] );
					getParentsOf( puid, parents );
				}
			}
		});

		
		function apiGet(resource, options) {
			options = options || {};
			options.filters = options.filters || "onlydata,onlyattrs";

			return $ApiHandler.get(resource, options)
			.then(function(response){
				return response.data;
			});
		}

		/***************************************/

		__fillDatamap( assets.datamaps.person = ({
			association:      { },
			surname:          { },
			forenames:        { },
			alt_name:         { single: 0, subs: { type: { type: "enum", values: "avionimi, entinen nimi, koko nimi, lempinimi, liikanimi, muu nimi, myöhempi nimi, nimimerkki, omaa sukua, peitenimi, puumerkki, rinnakkaisnimi, taiteilijanimi, vieraskielinen nimi, virallinen nimi" }}},
			addition:         { single: 0 },
			birth_date:       { },
			birth_place:      { },
			death_date:       { },
			death_place:      { },
			gender:           { },
			nationality:      { single: 0 },
			address:          { single: 0, subs: { postal_code: {}, city: {}, type: { type: "enum", values: "katuosoite, kotiosoite, käyntiosoite, postiosoite, työpaikan osoite" }}},
			email:            { single: 0 },
			phone:            { single: 0 },
			group:            { single: 0 },
			website:          { single: 0 },
			school_style:     { single: 0 },
			bio:              { },
			occupation:       { single: 0 },
			reference_number: { }
		}));

		/***************** VALUUTAT **********************/

		// https://docs.google.com/spreadsheets/d/1st8MyNC978fGj40M7uo5uUOefTm8-2831SZyTVU6ayo
		[["EUR","&euro;",978],["USD","$"],["GBP","&pound;"],["RUB"],["SEK","kr"],["NOK","kr"],["DKK","kr"],["ISK"],["BGN"],["CHF","&#8355;"],["CZK"],["PLN"],["RON","lei"],["HRK","kn"],["TRY"],["HUF","Ft"],["ZAR","R"],["ILS","&#8362;"],["JPY","&yen;"],["CAD","$"],["BRL","R$"],["MXN","&#8369;"],["HKD","$"],["THB"],["AUD","$"],["NZD","$"],["CNY","&yen;"],["IDR","Rp"],["INR","&#x20B9;"],["KRW","&#8361;"],["MYR","RM"],["PHP","&#8369;"],["SGD","$"],["FIM","fim"]].forEach(function( v ){
			v[0] = v[0].toUpperCase()
			assets.currencies.push( v[0] );
			assets.currencies_data[ v[0] ] = { code: v[0], symbol: $sce.trustAsHtml(v[1]||v[0]||"") };
			if (v[2]) assets.currencies_data[ v[0] ].number = v[2];
		});

		/***************************************/

		this.getCurrencies = function(){ return $q.when( self.currencies ); };

		this.getOeuvreProperties           = getOeuvreProperties;
		this.getOeuvreProperty             = getOeuvreProperty;
		this.getChildrenOfOeuvreProperty   = getChildrenOfOeuvreProperty;
		this.getChildrenOfOeuvreProperties = getChildrenOfOeuvreProperties

		this.generateFakeUID = this.generateUID = generateFakeUID;

		/**
		* [description]
		* @return {[type]} [description]
		*/
		var propertiesInitialized = false;
		function getOeuvreProperties(){
			if (assets.oeuvre_properties == null){
				console.debug("$helper.getOeuvreProperties() :: first time");

				assets.oeuvre_properties = apiGet('/oeuvres/properties').then(function(oeuvre_properties){
					return assets.oeuvre_properties = oeuvre_properties;
				})
			}

			var promise = $q.when(assets.oeuvre_properties);

			if (!propertiesInitialized) {
				propertiesInitialized = true;
				promise = promise.then(function( oeuvre_properties ){
					assets.oeuvre_properties = {};

					for( var uid in oeuvre_properties ) {
						assets.oeuvre_properties[uid] = new OeuvreProperty( oeuvre_properties[uid] );
					}

					oeuvre_properties = assets.oeuvre_properties;

					for( var uid in oeuvre_properties ){
						var subs = oeuvre_properties[uid].$subs = { };
						var path = oeuvre_properties[uid].$path = { };

						var parents = [];
						getParentsOf( uid, parents );
						path.title  = parents.reverse().map(function(item){
							return item.title + " > ";
						}).join( "" ) + oeuvre_properties[uid].title;
					}

					return oeuvre_properties;
				});
			}

			return promise.catch(function(err){
				console.error("$helper.getOeuvreProperties.catch()", err);
				throw err;
			});

			function getParentsOf( uid, parents ){
				var item = assets.oeuvre_properties[uid], puid = item.parent_method_uid;
				if (puid && assets.oeuvre_properties[ puid ]) {
					parents.push( assets.oeuvre_properties[ puid ] );
					getParentsOf( puid, parents );
				}
			}
		};
		getOeuvreProperties.asArray = function(){
			return getOeuvreProperties.then(Object.toArray);
		}

		/**
		* [description]
		* @param  {[type]} uids [description]
		* @return {[type]}      [description]
		*/
		function getOeuvreProperty(uids){
			return getOeuvreProperties()
			.then(function(oeuvre_properties){
				if (Array.isArray(uids)) {
					var response = {};
					for( var i in uids ) {
						if (oeuvre_properties[uids[i]]) {
							response[uids[i]] = oeuvre_properties[uids[i]];
						}
					}
					return response;
				} else {
					return oeuvre_properties[uids];
				}
			}).catch(function(err){
				console.error("$helper.getOeuvreProperty.catch()", err);
				throw err;
			});
		};

		/**
		* [description]
		* @param  {[type]} uids [description]
		* @return {[type]}      [description]
		*/
		function getChildrenOfOeuvreProperty( uid ){
			return getOeuvreProperties()
			.then(Object.toArray)
			.then(function(oeuvre_properties){
				return _getChildsOfProperties( oeuvre_properties, uid );
			})
			.catch(function(err){
				console.error("$helper.getChildrenOfOeuvreProperty.catch()", err);
				throw err;
			});

			function _getChildsOfProperties( properties, uid ){
				var arr = properties.filter(function(item){
					return item.parent_method_uid == uid && item.uid != uid;
				}), ret = [], subs;

				for( var i in arr ){
					ret.push( arr[i] );
					for( var e in (subs = _getChildsOfProperties( properties, arr[i].uid ))){
						ret.push( subs[e] );
					}
				}
				return ret;
			};
		};

		/**
		* [description]
		* @param  {[type]} uids [description]
		* @return {[type]}      [description]
		*/
		function getChildrenOfOeuvreProperties( uids ){
			if (!Array.isArray(uids)) uids = [ uids ];

			return $q.all(uids.filter(function(v, i, a){ return a.indexOf(v) == i; }).map(getChildrenOfOeuvreProperty))
			.then(function(oeuvre_properties){
				var ret = [];

				for( var i in oeuvre_properties ){
					for( var e in oeuvre_properties[i] ){
						ret.push(oeuvre_properties[i][e]);
					}
				}

				return ret;
			}).catch(function(err){
				console.error("$helper.getChildrenOfOeuvreProperties.catch()", err);
				throw err;
			});
		};

		/***************************************/

		this.setClients = function( clients ) {
			this.assets.clients = clients;
			for (var i in this.assets.clients) {
				this.fillClient( this.assets.clients[i] );
			}
			return this.assets.clients;
		}

		this.fillClient = function( client ) {
			if (!client.$domain && client.client_domain) {
				client.$domain = client.client_domain + "." + window.artestBaseDomain;
			}
		}

		this.getClients = function( opts ){
			return $q.when(assets.clients || $ApiHandler.get("/users/me/clients", {
				filters: "onlydata,onlyattrs"
			}).then(function(response) {
				return self.setClients( response.data );
			}));
		};

		this.getClientsLists = function( opts ){
			return $q.when( self.getClients().then(function( clients ){
				assets.clients_lists = {};
				return $q.all(Object.keys(clients).map(function( client_uid ){
					return $ApiHandler.get("/clients/"+ client_uid +"/lists/oeuvres", {
						filters: "onlydata,onlyattrs"
					}).then(function( response ){
						for( var list_uid in response.data ) {
							assets.clients_lists[ list_uid ] = response.data[ list_uid ];
						}
						assets.clients[ client_uid ].lists = response.data;
					})
				}));
			}).then(function(){
				return assets.clients_lists;
			}));
		};
		this.getClientLists = (function( __fetching_prms ) {
			return function( client_uid ) {
				if (__fetching_prms[ client_uid ]) return $.when( __fetching_prms[ client_uid ] );

				if (assets.clients && assets.clients[ client_uid ] && assets.clients[ client_uid ].lists) return $q.resolve( assets.clients[ client_uid ].lists );

				return __fetching_prms[ client_uid ] = self.getClients().then(function( clients ){
					if (!clients[ client_uid ]) throw "Invalid argument";
		
					return $ApiHandler.get("/clients/"+ client_uid +"/lists/oeuvres", {
						filters: "onlydata,onlyattrs"
					}).then(function( response ){
						assets.clients_lists = assets.clients_lists || {};

						for( var list_uid in response.data ) {
							assets.clients_lists[ list_uid ] = response.data[ list_uid ];
						}

						delete __fetching_prms[ client_uid ];

						return assets.clients[ client_uid ].lists = response.data;
					});
				});
			};
		})({ });

		this.refreshClientsLists = refreshClientsLists;

		function refreshClientsLists( opts ) {

			var client_uid = opts.client_uid;

			return $timeout(function() {
				
				if (!client_uid || !assets.clients[ client_uid ]) return;

				for (var uid in assets.clients[ client_uid ].lists) {
					delete assets.clients_lists[ uid ];
				}

				delete assets.clients[ client_uid ].lists;

				return self.getClientLists( client_uid );

			}).then(function() {

				$rootScope.$broadcast( "$userAssets.clientsListsRefreshed", { client_uid: client_uid });
			});
		};

		this.getClientArtistRaw = function( client_uid, client_artist_uid, opts ){
			opts = opts || {};

			return $ApiHandler.get('/clients/' + client_uid + '/artists/' + client_artist_uid, {
				with:    opts.with    || "artist,oeuvre,details",
				filters: opts.filters || "asarray,onlydata,onlyattrs"
			}).then(function( response ){
				return response.data[ Object.keys(response.data)[0] ];
			});
		};
		this.getClientArtistsRaw = function( client_uid, client_artists_uids, opts ){
			return $q.all(client_artists_uids.map(function( client_artist_uid ){
				return self.getClientArtistRaw( client_uid, client_artist_uid, opts );
			}));
		};
		this.getClientsArtists = (function(){
			var __fetching_prms = {};

			return function( opts ){
				var client_uid = opts.client_uid;
				return $q.when(assets.clients[client_uid] && assets.clients[client_uid].artists || fetch( client_uid ));
			}

			function fetch( client_uid ){
				if( !__fetching_prms[ client_uid ]){
					__fetching_prms[ client_uid ] = self.getClients().then(function(clients){
						assets.clients_artists = assets.clients_artists || {};
						assets.artists         = assets.artists         || {};

						return $ApiHandler.get("/clients/"+ client_uid +"/artists", {
							filters : "onlydata,onlyattrs",
							with    : "artist"
						});

					}).then(function( response ){

						for( var uid in response.data ) {
							var client_artist = assets.clients_artists[ uid ] = assets.clients_artists[ uid ] || response.data[ uid ];

							assets.artists[ client_artist.artist_uid ] = assets.artists[ client_artist.artist_uid ] || response.data[uid].with.artist;

							client_artist.search_str = client_artist.search_str || buildSearchStr( client_artist );
						}

						assets.clients[client_uid].artists = {};
						for( var uid in response.data ) {
							assets.clients_artists[uid].with.artist = assets.artists[assets.clients_artists[uid].artist_uid];
							assets.clients[client_uid].artists[ uid ] = assets.clients_artists[ uid ];
						}

						delete __fetching_prms[ client_uid ];
						return assets.clients[client_uid].artists;
					}).then(injectArtistsSearchKeys);
				}

				return $q.when( __fetching_prms[ client_uid ]);
			}

			function buildSearchStr( client_artist ){
				return self.filterString2searchKey( client_artist.name, client_artist.with.artist && client_artist.with.artist.name, client_artist.badge, client_artist.description );
			}
		})();

		this.refreshClientArtists = refreshClientArtists;

		function refreshClientArtists( opts ) {

			var client_uid = opts.client_uid;

			return $timeout(function() {

				if (!client_uid || !assets.clients[ client_uid ]) return;

				for (var uid in assets.clients[ client_uid ].artists) {
					delete assets.clients_artists[ uid ];
				}

				delete assets.clients[ client_uid ].artists;

				return self.getClientsArtists({ client_uid: client_uid });
			});
		}


		this.getClientOeuvres = (function( __fetching_prms ){
			return function( opts ) {
				var client_uid = opts.client_uid;
				return $q.when(( assets.clients[ client_uid ] && assets.clients[ client_uid ].oeuvres ) || fetch( client_uid ));
							
			};
			function fetch( client_uid ){
				if (!__fetching_prms[ client_uid ]) {
					__fetching_prms[ client_uid ] = fetchRaw( client_uid ).then(function( response ){
						/* Lisätty 21.12.2020 kun käynyt ilmi "tuplavälimuisti (assets.clients[ client_uid ].oeuvres'n
						 * tyhjentäminen ei riitä uudelleennoutamisen vaatimiseksi sillä __fetching_prms[ client_uid ] resolvaa aiemman tuloksen)
						 * Tämä oli huomioitu getClientsArtists'ssa jo aiemmin -m */
						 
						delete __fetching_prms[ client_uid ];
						return response;
					});
				}

				return $q.when( __fetching_prms[ client_uid ]);
			}

			function fetchRaw( client_uid ) {
				return self.getClients().then(function( clients ){
					assets.clients_oeuvres = assets.clients_oeuvres || {};
					return $ApiHandler.get("/clients/"+ client_uid +"/oeuvres", {
						filters : "onlydata,onlyattrs",
						with    : "oeuvres,images"
					});
				})
				.then(function( response ){
					return self.getOeuvreProperties().then(function(oeuvre_properties){
						for( var oeuvre_uid in response.data ) {
							var oeuvre = response.data[ oeuvre_uid ];

							oeuvre.with.oeuvre.$img_uid = oeuvre.with.oeuvre.img_uid || assets.clients[ oeuvre.client_uid ].defaults.placeholder_oeuvre_img_uid || "B20000000000009B";

							oeuvre.methods = oeuvre.with.oeuvre.methods_uids.map(function(uid){
								return oeuvre_properties[uid];
							}).filter(function(method) {
								return !!method;
							});
						}
						return response.data;
					});
				})
				.then(function(oeuvres){
					return self.getClientsArtists({ client_uid: client_uid }).then(function( artists ){

						if( Object.keys(artists).length == 0 && Object.keys(oeuvres).length > 0 ) console.warn("Asiakkaalla '"+ client_uid +"' on teoksia, muttei yhtään taiteilijaa!?", assets.clients[ client_uid ], oeuvres, artists );

						for( var oeuvre_uid in oeuvres ){
							if( artists[ oeuvres[ oeuvre_uid ].artist_uid ]){
								oeuvres[ oeuvre_uid ].with.client_artist = artists[ oeuvres[ oeuvre_uid ].artist_uid ];
								oeuvres[ oeuvre_uid ].with.artist        = artists[ oeuvres[ oeuvre_uid ].artist_uid ].with.artist;
							}
						}
						return oeuvres;
					});
				})
				.then(injectOeuvresSearchKeys)
				.then(function( oeuvres ){
					for( var oeuvre_uid in oeuvres ) {
						var oeuvre = oeuvres[ oeuvre_uid ];

						try {
							oeuvre.$warnings = [];
							if (!oeuvre.with.oeuvre) {
								oeuvre.$warnings.push( gettextCatalog.getString( "The oeuvre does not have a global oeuvre data" ));
							} else if (!oeuvre.with.oeuvre.owner_uid) {
								oeuvre.$warnings.push( gettextCatalog.getString( "The oeuvre is not owned by anyone" ));
							} else if (oeuvre.with.oeuvre.owner_uid != oeuvre.client_uid) {
								oeuvre.$warnings.push( gettextCatalog.getString( "The oeuvre is owned by {{ owner }}, not by {{ client }}", {
									owner:  assets.clients[oeuvre.with.oeuvre.owner_uid] && assets.clients[oeuvre.with.oeuvre.owner_uid].name || oeuvre.with.oeuvre.owner_uid,
									client: assets.clients[oeuvre.client_uid]            && assets.clients[oeuvre.client_uid].name            || oeuvre.client_uid 
								}));
							}
						} catch(err) {
							console.error( err );
						}

						try {
							oeuvre.$title = oeuvre.with.oeuvre.title;
							if (oeuvre.with.oeuvre.print_number>1 || oeuvre.with.oeuvre.print_count>1) {
								oeuvre.$print_str = oeuvre.with.oeuvre.print_number + "/" + oeuvre.with.oeuvre.print_count;
								oeuvre.$title += ", " + oeuvre.$print_str;
							}
							if (oeuvre.with.oeuvre.completed) {
								oeuvre.$title += " (" + oeuvre.with.oeuvre.completed + ")";
							}
						} catch( err ) {
							console.error( err );
						}

						assets.clients_oeuvres[ oeuvre_uid ] = oeuvre;
					}
					return assets.clients[ client_uid ].oeuvres = oeuvres;
				});
			}
		})({});

		this.getClientsOeuvres = function(opts) {
			if( opts.client_oeuvre_uids && opts.raw ) return this.getClientsOeuvresRaw( opts.client_oeuvre_uids );

			return $q.when(assets.all_clients_oeuvres || self.getClients().then(function(clients){
				return $q.all(Object.keys(clients).map(function(client_uid){
					return self.getClientOeuvres({ client_uid: client_uid })
				}));
			}).then(function(){
				return assets.all_clients_oeuvres = assets.clients_oeuvres;
			}));
		};
		this.getClientsOeuvresRaw = function( uids, blen ){
			var oeuvres = {}, blocks = [];
			blen = blen || 20;
			uids = this.filterUidArray( uids, [ "92" ]);

			for( var p, i = 0; i < uids.length; i++ ){
				(blocks[ p = parseInt( i / blen )] = blocks[ p ] || [ ]).push( uids[ i ]);
			}

			return $q.all(blocks.map( function( uids ){
				return $ApiHandler.get( "/clients/oeuvres", {
					clients_oeuvres_uids: uids.join(","),
					filters: "onlydata,onlyattrs"
				}).then(function( response ){
					for( var uid in response.data ) oeuvres[ uid ] = response.data[ uid ];
				});
			})).then(function(){
				return oeuvres;
			});
		};

		/***********************/

		this.updateOeuvre = (function( handlers ){
			return function( oeuvre, data ) {
				console.log( "ArtestUserAssets.updateOeuvre()", oeuvre, data );

				var body = {
					"oeuvre.uid": oeuvre.oeuvre_uid
				};

				for (var key in data) {
					if (handlers[ key ]) handlers[key]( body, data[key] );
					else console.warn( "ArtestUserAssets.updateOeuvre :: Got key in data that does not have a hander.", key, data );
				}

				return $ApiHandler.post( "/oeuvres/"+ oeuvre.oeuvre_uid, null, body )
				.then(function( resp ){
	//				return $ApiHandler.get( "/oeuvres/" + oeuvre.oeuvre_uid, { filter: "asarray,onlydata,onlyattrs" });
				});
			};
		})({
			datamap:      function( b, v ){ b["oeuvre.datamap"]      = v; },
			availability: function( b, v ){ b["oeuvre.availability"] = v; },
			visibility:   function( b, v ){ b["oeuvre.visibility"]   = parseInt(v); },
			description:  function( b, v ){ b["oeuvre.description"]  = v || ""; }
		});

		this.updateClientOeuvre = (function( handlers ){
			return function( oeuvre, data ) {
				console.log( "ArtestUserAssets.updateClientOeuvre()", oeuvre, data );

				var body = {
					"client_oeuvre.client_uid" : oeuvre.client_uid,
					"client_oeuvre.uid"        : oeuvre.uid
				};

				for (var key in data) {
					if (handlers[ key ]) handlers[key]( body, data[key] );
					else console.warn( "ArtestUserAssets.updateClientOeuvre :: Got key in data that does not have a hander.", key, data );
				}

				return $ApiHandler.post( "/clients/"+ oeuvre.client_uid +"/oeuvres/"+ oeuvre.uid, null, body )
				.then(function( resp ){
	//				return $ApiHandler.get( "/clients/"+ oeuvre.client_uid +"/oeuvres/" + oeuvre.uid, { filter: "asarray,onlydata,onlyattrs" });
				});
			};
		})({
			unique_identifier: function( b, v ){ b["client_oeuvre.unique_identifier"] = v && String(v); },
			prices: function( body, prices ){
				body["client_oeuvre.prices"] = (prices||[]).map(function( price ){
					/** @TODO: Validoi price */
					if (typeof price == "object" && Array.isArray( price )) return price;
					else console.warn( "ArtestUserAssets.updateClientOeuvre :: Invalid argument. Non-array item in 'prices'", price );
				}).filter(function(v){ return v; });
			}
		});

		function bodyBuilderBuilder( base, data, handlers ){}


		this.refreshClientOeuvres = refreshClientOeuvres;

		function refreshClientOeuvres( opts ) {

			var client_uid = opts.client_uid;

			return $timeout(function() {
				
				if (!client_uid || !assets.clients[ client_uid ]) return;

				for (var uid in assets.clients[ client_uid ].oeuvres) {
					delete assets.clients_oeuvres[ uid ];
				}

				delete assets.clients[ client_uid ].oeuvres;

				return self.getClientsOeuvres({ client_uid: client_uid });
			});
		};

		/*************************/

		this.getClientAuctions = function( opts ){
			var client_uid  = opts.client_uid;
			var auction_uid = opts.client_auction_uid;

			return $q.when((assets.clients[client_uid] && assets.clients[client_uid].auctions) || self.getClients().then(function( clients ){
				var client = clients[ client_uid ] || {};

				return $ApiHandler.get( "/clients/"+ client_uid +"/auctions", {
					filters: "onlydata,onlyattrs"
				}).then(function( response ){
					var auctions = response.data;

					client.auctions           = {};
					client.$auctions_byTarget = {};

					for( var uid in auctions ){
						var auction = client.auctions[ uid ] = auctions[ uid ];
						for( var target_uid in auction.with.targets ){
							if( client.$auctions_byTarget[ target_uid ]){
								console.warn( "Target "+target_uid+" is target in multiple auctions! Ignoring", auction.with.targets[target_uid] );
							} else {
								client.$auctions_byTarget[ target_uid ] = auction;
							}
						}
					}

					return client.auctions;
				});
			}))
		};

		/*********************/

		this.getClientObjectEntryEvents = function( client_uid, target_uids ) {
			if (target_uids) { console.warn( "use $userAssets.getClientObjectEntryEventsRaw()" ); return this.getClientObjectEntryEventsRaw( client_uid, target_uids ); };

			return $q.when((assets.clients[client_uid] && assets.clients[client_uid].object_entry_events) || self.getClients().then(function( clients ){
				var client = clients[ client_uid ] || {};

				return $ApiHandler.get( "/clients/"+ client_uid +"/object_entry_events", {
					filters: "onlydata,onlyattrs"
				}).then(function( response ){
					var data = client.object_entry_events = response.data;

					return client.object_entry_events;
				})
			}));
		};
		this.getClientObjectEntryEventsRaw = function( client_uid, target_uids ) {
			var uids = [], results = {};
			target_uids.forEach(function( uid, i ){
				(uids[ i = Math.floor(i / 50) ] = uids[ i ] || []).push( uid );
			});

			return $q.allIterator( uids.map(function( uids ){
				return function(){
					return $ApiHandler.get( "/clients/"+ client_uid +"/object_entry_events?target_uids=" + uids, {
						filters: "onlydata,onlyattrs"
					}).then(function( response ){
						for (var uid in response.data) results[uid] = response.data[ uid ];
					});
				}
			})).then(function(){
				return results;
			});
		};
		this.injectClientObjectEntryEvents = function( client_uid, targets ){
			var targets_obj = {};
			if (Array.isArray( targets )) {
				targets.forEach(function( target ){ targets_obj[ target.uid ] = target; });
			} else if (typeof targets == "object" && targets != null) {
				targets_obj = targets;
			} else throw "Invalid argument";

			return this.getClientObjectEntryEventsRaw( client_uid, Object.keys(targets_obj) ).then(function( results ){
				for (var i in targets) {
					var target = targets[i];
					target.with                     = target.with                     || {};
					target.with.object_entry_events = target.with.target_entry_events || {};
				}
				for (var i in results) {
					var target = targets_obj[ results[i].target_uid ];
					if (target) target.with.object_entry_events[ results[i].uid ] = results[i];
				}
				return targets;
			});
		}

		/*********************/

		this.getOeuvreDatamap = function(){
			return $q.when( assets.datamap || $ApiHandler.get( "/oeuvres/datamap", {
				filters: "onlydata"
			}).then(function( response ){
				build_horizontal( assets.datamap = response.data, assets.datamap_horizontal = {} );

				for (var key in assets.datamap_horizontal) {
					var skey = key.split( "." );
					for (var i in skey) {
						var _t_tmp = gettextCatalog.getStringIfExists( "ODM." + skey.slice( i ).join("."));
						if (_t_tmp) {
							assets.datamap_horizontal[ key ].$i18n_title = _t_tmp;
							break;
						}
					}

					assets.datamap_horizontal[ key ].$i18n_description = gettextCatalog.getStringIfExists( "ODM-description:" + key );
					assets.datamap_horizontal[ key ].$i18n_placeholder = gettextCatalog.getStringIfExists( "ODM-placeholder:" + key );
							
					if (assets.datamap_horizontal[ key ].type == "enum") {
						assets.datamap_horizontal[ key ].$i18n_values = {};
						assets.datamap_horizontal[ key ].values.forEach(function( value ){
							for (var i = 0; i < skey.length; i++) {
								var str = gettextCatalog.getStringIfExists( "ODM-enum." + skey.slice( i, skey.length ).join( "." ) + ":" + value );
								if (str) {
									return assets.datamap_horizontal[ key ].$i18n_values[ value ] = str;
								}
							}
						});
					}
				}

				return assets.datamap;

				function build_horizontal( level, ret ){
					for( var key in level ){
						var v = ret[ level[ key ].key ] = level[ key ];

						build_horizontal( v.subs, ret );
					}
				}
			}));
		};

		this.getOeuvreDatamapHorizontal = function(){
			return this.getOeuvreDatamap().then(function(){
				return assets.datamap_horizontal;
			});
		};

		// Väliaikainen purkkatoteutus -M 04.02.2020
		this.getObjectEntityEventsDatamap = (function( OEEDM_raw ){
			return function(){
				/******************************/
				return $q.when( assets.OEEDM || $q.resolve({ data: OEEDM_raw }).then(function( response ){
					/**************************/
					build_horizontal( assets.OEEDM = response.data, assets.OEEDM_horizontal = {});

					for (var key in assets.OEEDM) {
						__fillDatamap(assets.OEEDM[ key ].subs, null, function( item ){
							var $parts = item.$key.split( "." ), $i18n_title;

							for (var i = 0; i < $parts.length; i++) {
								if ($i18n_title = gettextCatalog.getStringIfExists( "OEEDM." + key + "." + $parts.slice( i, $parts.length ).join( "." ))) break;
							}

							if (!$i18n_title) {
								for (var i = 0; i < $parts.length; i++) {
									if ($i18n_title = gettextCatalog.getStringIfExists( "OEEDM." + $parts.slice( i, $parts.length ).join( "." ))) break;
								}
							}

							if ($i18n_title) item.$i18n_title = $i18n_title;
						});
					}

				})).then(function(){
					return JSON.parse( JSON.stringify( assets.OEEDM ));
				});
			}

			function build_horizontal( level, ret ){
				for( var key in level ){
					var v = ret[ level[ key ].key ] = level[ key ];

					build_horizontal( v.subs, ret );
				}
			}
		})({
			"object_audit":{"subs":{"type":{},"category":{},"date":{},"method":{},"auditor":{},"result":{}}},
			"loss_damage":{"subs":{"date":{},"reporter":{},"method":{}}},
			"exhibition":{"subs":{"name":{"required":true},"organiser":{},"venue":{"required":true,"subs":{"authoriser":{}}}}},
			"usecase":{"subs":{"user":{},"date":{},"method":{},"provisos":{},"result":{}}},
			"object_conservation":{"subs":{"plan":{},"conservator":{},"material":{},"report":{}}},
			"indemnity":{"subs":{"min_liability_sum":{"subs":{"currency":{}}},"confirmation_date":{}}},
			"movement":{"subs":{"planned_date":{},"contact":{},"method":{},"date":{}}},

			"condition":{ "subs":{
				"date":{"type":"datetime"},
				"completeness": { "type":"enum", "values":[ "WHOLE","INCOMPLETE","PARTS_MISSING","ALL_PARTS_PRESERVED","EXHIBITION_SUITABLE" ], "subs": { "note":{}, "date":{}}},
				"technical_assessment":{"subs":{"date":{}}},
				"review_date":{"type":"date"},
				"conservation_treatment_priority":{"subs":{"note":{}}},
				"environmental_condition":{"subs":{"begin_date":{},"end_date":{}}},
				"hazard":{"subs":{"date":{},"note":{}}}}},

			"loan_out":{"subs":{"borrower":{},"contact_person":{},"conditions":{}}},
			"loan_in":{"subs":{"lender":{"subs":{"authoriser":{},"authorisation_date":{},"contact":{}}},"contact":{},"conditions":{}}},
			"rights_out":{"subs":{"type":{},"authoriser":{},"date":{},"requester":{},"consent_status":{"subs":{"date":{}}}}},
			"rights_in":{"subs":{"type":{},"holder":{}}},
			"object_out":{"subs":{"delivery_date":{},"exit_date":{},"destination":{},"method":{},"courier":{},"shipping":{"subs":{"shipper":{"subs":{"contact":{}}},"note":{}}}}},
			"disposal":{"subs":{"deaccession_date":{},"disposal_date":{},"method":{},"provisos":{},"recipient":{},"new":{"subs":{"object_reference_number":{},"price":{"subs":{"currency":{}}}}}}},
			"process":{"subs":{"method":{},"date":{},"actor":{}}},
			"object_valuation":{"subs":{"valuer":{},"value":{"subs":{"currency":{}}},"type":{},"date":{},"renewal":{}}},
			"insurance":{"subs":{"policy_number":{},"insurer":{},"renewal_date":{}}},
			"sale":{"subs":{"client":{},"authoriser":{},"date":{},"exit_date":{},"conditions":{"subs":{"pricing":{"subs":{"currency":{}}}}}}},
			"rent":{"subs":{"client":{},"authoriser":{},"date":{},"conditions":{"subs":{"installment_count":{},"installment_amount":{}}}}},
			"rent_in":{"subs":{"rent_out_reference_number":{},"client":{},"recipient":{},"date":{},"inspection":{"subs":{"inspector":{},"date":{},"report":{}}}}},
			"rent_sale":{"subs":{"client":{},"authoriser":{},"date":{},"conditions":{}}},
			"publication":{"subs":{"type":{"required":true},"publisher":{},"authoriser":{},"date":{},"publish_date":{},"terms":{},"circulation":{}}}
		});

		/** Väliaikainen */
		this.__fillDatamap = __fillDatamap;
		function __fillDatamap( level, parent, callback ){
			for( var key in level ){
				var value = level[ key ];

				value.type   = value.type || "text";
				value.single = value.single == null ? true : !!value.single;

				switch (value.type) {
					case "currency": 
						value.type   = "enum";
						value.values = assets.currencies;
						break;
				}
				
				if (value.type=="enum" && angular.isString(value.values)) value.values = value.values.trim().split(/\s*,\s*/);

				value.$key = value.key = key;
				if (parent) value.$key = parent.$key + "." + value.$key;

				if (callback) callback( value, parent );

				__fillDatamap( value.subs, value, callback );
			}
		};



		/*********************/

		/**
		 * Ladataan tietoa vain APIlta
		 * */
		this.getAttachment = function( uid ){
			return $q.when( assets.attachments[ uid ] || $ApiHandler.get( "/attachments/"+uid, {
				"filters": "asarray,onlydata,onlyattrs"
			}).then(function( attachment ) {

				attachment = attachment && attachment.data && attachment.data[0];

				try {
					var ext;

					if (attachment.filename) {
						ext = attachment.filename.substr( attachment.filename.lastIndexOf( "." ));
					}

					if (ext) {
						attachment.$downloadUrl = artestRootDomain + "/ajax/attachments/" + uid + ext;
					}
				} catch (error) { console.error( error ); }

				return assets.attachments[ uid ] = attachment;
			}));
		};

		this.getAttachmentData = function( uid ){
			throw new Error( "Not implemented yet!" );
		};

		/** @note Erityistapaus datan lataamisesta */
		this.getAttachmentData.asTHREEObject = (function( attachment_objects ){
			return function( uid, donotfix ){
				return $q.when( attachment_objects[ uid ] || (attachment_objects[ uid ] = self.getAttachment( uid ).then(function( attachment ){

					/** @note: onkoha hyvä tarkistaa vasta tässä kohtaa? */
					if (!THREE || !THREE.ObjectLoader) throw new Error( "$userAssets.getAttachment.asTHREEObject :: THREE.ObjectLoader not available" );
					var url = "/ajax/attachments/"+ attachment.uid +".json";

					return $q(function( resolve, reject ){
						return new THREE.ObjectLoader().load( url, resolve, function( xhr ){
							console.log("$userAssets.getAttachment.asTHREEObject :: Loading attachment('"+ attachment.uid +"')",  Math.round(xhr.loaded / xhr.total * 100, 2) + '%');
						}, reject);
					}).then(function( mesh ){
						if (donotfix) return mesh;

						switch( mesh.type ){
							case "Scene":
								mesh = (new THREE.Object3D()).copy( mesh );
								break;
						}

						return mesh;
					});
				}))).then(function( object ){
					return (attachment_objects[ uid ] = object).clone();
				});
			};
		})( assets.attachment_objects = {} );


		/*********************/

		var filterString2searchKey = this.filterString2searchKey = (function(){
			/* @TODO: voiko optimoida yhdistämällä? */
			var regexp_torm  = /[\s\.,:'\(\)\[\]\{\}\/\\]/g; // Poistettavat (whitespacella korvattavat) merkit
			var regexp_toosm = /\s[a-zåäö]{0,3}\s/g;         // Liian lyhyet whitespacen ympäröimät merkkijonot ( 0-3 merkkiä) (myös whitespacen, (2-5 merkkiä))

			return function( str ) {
				if (arguments.length > 1) return self.filterString2searchKey( Array.prototype.slice.call( arguments ));
				if (Array.isArray( str )) str = parseArray2string( str );
				if (typeof str != "string") return console.warn( "$userAssets.filterString2searchkey :: Invalid argument", typeof str, str ), "";

				return (" " + str.toLowerCase().replace( regexp_torm, " " ) + " ").replace( regexp_toosm, " " ).trim();
			};

			function parseArray2string( arr ){
				return arr.filter(function( v ) {
					return !!v;
				}).map(function( v ) {
					return Array.isArray( v ) ? parseArray2string( v ) : v;
				}).join(" ");
			}
		})();

		this.injectOeuvresSearchKeys = injectOeuvresSearchKeys;
		function injectOeuvresSearchKeys( data ){
			var searchStringHandlers = {
				unique_identifier  : { filter: function(v){ return v; } },
				client_artist_name : { filter: function(v){ return v; } },
				oeuvre_title       : { filter: function(v){ return v; } }
			};

			for (var i in data) try {

				// @TODO: jotta voi kohdistaa hakutuloksen
				// Horisontaalinen avain:arvo
				var search_obj = {
					properties                : data[i].methods.map(function(v){ return v.title }).join(" "),
					description               : data[i].description,
					oeuvre_title              : data[i].with.oeuvre.title,
					oeuvre_description        : data[i].with.oeuvre.description,
					oeuvre_canvas_description : data[i].with.oeuvre.canvas_description,
					oeuvre_method_description : data[i].with.oeuvre.method_description,
					unique_identifier         : data[i].unique_identifier
				};

				if (data[i].with.datamap) {
					search_obj.datamap_content_tags = "";

					try {
						data[i].with.datamap.description.forEach(function( v ) { 
							v.subs.content.forEach(function( v ) {
								v.subs.tags.forEach(function( v ) {
									search_obj.datamap_content_tags += v.value + " ";
								});
							});
						});
					} catch (err) {}

					try {
						search_obj.datamap_location = "";

						if (Object.keys(data[i].with.datamap.location).length > 0 ) {
							var locations = data[i].with.datamap.location;

							for (var j in locations) {
								search_obj.datamap_location += (locations[j].value || "");

								if (locations[j].subs)  {
									if (locations[j].subs.current_location) {
										try {
											search_obj.current_location += " " + locations[j].subs.current_location.map(function(v){ return v.value; }).join(" ");
										} catch(e) {}
									}
									if (locations[j].subs.normal_location) {
										try {
											search_obj.datamap_location += " " + locations[j].subs.normal_location.map(function(v){ return v.value; }).join(" ");
										} catch(e) {}
									}
								}
							}
						}

						search_obj.datamap_location = search_obj.datamap_location.toLowerCase();
					} catch (err) { }
					
				
					try {
						search_obj.datamap_collection = "";

						var object      = data[i].with.datamap.object && data[i].with.datamap.object[0] || {};
						var collections = object.subs && object.subs.collection || [];

						for (var j in collections) {

							if (collections[j].value) {
							
								if (search_obj.datamap_collection) search_obj.datamap_collection += " ";

								search_obj.datamap_collection += collections[j].value;
							}
						}
					} catch (err) { }


					try { /** Historiatietoihin merkitty "toimija" */
						search_obj.datamap_history_production_actor = "";

						data[i].with.datamap.history.forEach(function( v ) { 
							v.subs.production.forEach(function( v ) {
								v.subs.actor.forEach(function( v ) {
									search_obj.datamap_history_production_actor += v.value + " ";
								});
							});
						});
					} catch (err) { }


					try { /** Objektitietoihin merkitty "muu tunnus" */
						search_obj.datamap_object_identifier = "";

						data[i].with.datamap.object.forEach(function( v ) { 
							v.subs.identifier.forEach(function( v ) {
								search_obj.datamap_object_identifier += v.value + " ";
							});
						});
					} catch (err) { }
				}

				if (data[i].$search) {
					console.warn( "injectOeuvresSearchKeys :: Oeuvre has already $search" );
				}

				data[i].$search = data[i].$search || new SearchString( null, searchStringHandlers );
				data[i].$search.extend( data[i].search_str );
				data[i].$search.extend( data[i].with.oeuvre.search_str );
				data[i].$search.extend( search_obj );

				try {
					if (data[i].with.client_artist != null) {
						data[i].$search.extend({ client_artist_name: data[i].with.client_artist.name });
					}
				} catch(e) {}

				data[i].search_str = data[i].$search.$string;
			} catch( err ) { console.warn( err ); }
			return data;
		}

		this.injectArtistsSearchKeys = injectArtistsSearchKeys;
		function injectArtistsSearchKeys( data ){
			var searchStringHandlers = {
				client_artist_name : { filter: function(v){ return v; } }
			};

			for (var i in data) try {
				var item = data[i];
				if (item.$search) console.warn( "injectArtistsSearchKeys :: Artist has already $search" );
				
				item.$search = item.$search || new SearchString( null, searchStringHandlers );

				var search_obj = {
					client_artist_name  : item.name,
					client_artist_badge : item.badge,
					description         : ((item.description || "") +" "+ (item.with.artist && item.with.artist.description || "")).trim() || undefined,
				};

	//			item.$search.extend( item.search_str );
				item.$search.extend( search_obj );

				item.search_str = item.$search.$string;

			} catch( err ) { console.warn( err ); }

			return data;
		}

		/*********************/

		function SearchString( argv, handlers ){
			this.$string   = "";
			this.$contains = {};
			this.handlers  = handlers || {};

			argv && this.extend( argv );
		}
		SearchString.prototype.extend = function( argv ){
			var str = null;
			if (typeof argv == "object") {
				str = "";
				for (var key in argv) {
					if (typeof argv[ key ] == "number") argv[ key ] = argv[ key ].toString(10);

					if (typeof argv[ key ] == "string") {

						if (!this.handlers[ key ]) this.handlers[ key ] = { };

						try {
							// Standardifiltteri
							argv[ key ] = argv[ key ].toLowerCase().trim();

							if (this.handlers[ key ].filter) {
								argv[ key ] = this.handlers[ key ].filter( argv[ key ] );
							} else {
								argv[ key ] = filterString2searchKey( argv[ key ]);
							}
						} catch( e ) { console.warn(e); }

						if (this.$contains[ key ]) {
							this.$contains[ key ] += " " + argv[ key ];
						} else {
							this.$contains[ key ] = argv[ key ];
						}

						str += " " + argv[ key ];
					} else if (argv[ key ] != null) {
						console.warn( "SearchString.extend :: Invalid argument argv. Not typeof 'string'", argv[ key ]);
					}
				}
			} else if (typeof argv == "string") {
				str = " " + argv;
			} else if (typeof argv == "number") {
				str = " " + argv.toString();
			} else if (argv) {
				console.warn( "SearchString.extend :: Invalid argument" );
			}

			if (typeof str == "string") {
				this.$string += str;
			}
		}
		SearchString.prototype.toString = function() {
			return this.$string;
		}
		window.SearchString = SearchString;

		/*********************/

		this.filterUidArray = function( arr, filter ){
			switch( typeof filter ){
				case "function":
					return arr.filter(function( uid, i ){
						if( arr.indexOf( uid ) != i ) return false;
						return filter( uid, i, arr );
					});
				case "object":
					if( Array.isArray( arr )) return arr.filter(function( uid, i ){
						if( arr.indexOf( uid ) != i ) return false;
						return filter.indexOf( uid[0]+uid[1] ) != -1;
					});
			}
			return arr.filter(function( uid, i ){
				return arr.indexOf( uid ) == i;
			});
		};


		this.getClientSingles = function( uids ){
			if( typeof uids == "string") uids = [ uids ];
			if(!Array.isArray( uids )) throw "Invalid argument";

			var nuids = uids.filter(function( uid ){
				return !assets.clients[ uid ];
			});

			return $q.when( nuids.length == 0 ? [] : $ApiHandler.get("/clients", {
				where: JSON.stringify({ uid: { $in: nuids } }),
				filters: "asarray,onlydata,onlyattrs"
			}).then(function( response ){
				for( var i in response.data ){
					if (assets.clients[ response.data[ i ].uid ]){
						response.data[ i ].with = angular.extend( response.data[ i ].with || {}, assets.clients[ response.data[ i ].uid ].with || {} );
					}
					assets.clients[ response.data[ i ].uid ] = angular.extend( assets.clients[ response.data[i].uid ] || {}, response.data[i] );
					self.fillClient( assets.clients[ response.data[ i ].uid ] );
				}
			})).then(function(){
				return uids.map(function( uid ){
					return assets.clients[ uid ];
				});
			});
		};
		this.getClientOeuvreSingles = function( uids ){
			if( typeof uids == "string") uids = [ uids ];
			if(!Array.isArray( uids )) throw "Invalid argument";

			var nuids = uids.filter(function( uid ){
				return !assets.clients_oeuvres[ uid ];
			});

			return $q.when( nuids.length == 0 ? [] : $ApiHandler.get("/clients/oeuvres", {
				clients_oeuvres_uids: nuids.join(","),
				filters: "asarray,onlydata,onlyattrs",
				with: "images,client_artist"
			}).then(function( response ){
				for( var i in response.data ){
					if (assets.clients_oeuvres[ response.data[ i ].uid ]){
						response.data[ i ].with = angular.extend( response.data[ i ].with || {}, assets.clients_oeuvres[ response.data[ i ].uid ].with || {} );
					}
					assets.clients_oeuvres[ response.data[ i ].uid ] = response.data[ i ];
				}
			})).then(function(){
				return uids.map(function( uid ){
					return assets.clients_oeuvres[ uid ];
				});
			});
		};
		this.getClientArtistSingles = function( uids ){
			if( typeof uids == "string") uids = [ uids ];
			if(!Array.isArray( uids )) throw "Invalid argument";

			var nuids = uids.filter(function( uid ){
				return !assets.clients_artists[ uid ];
			});

			var prmss = Object.keys( assets.clients ).map(function( client_uid ){
				return $ApiHandler.get("/clients/"+ client_uid +"/artists", {
					"where": JSON.stringify({ uid: { $in : nuids }}),
					filters: "asarray,onlydata,onlyattrs"
				}).then(function( response ){
					response.data.forEach(function( artist ){
						if (assets.clients_artists[ artist.uid ]){
							artist.with = angular.extend( artist.with || {}, assets.clients_artists[ artist.uid ].with || {} );
						}
						assets.clients_artists[ artist.uid ] = artist;
					});
				})
			});

			return $q.resolve( nuids.length == 0 ? [] : $q.all( prmss )).then(function(){
				return uids.map(function( uid ){
					return assets.clients_artists[ uid ];
				}).filter(function( v ){
					return v;
				});
			});
		};


		/*********************/

		this.getArtestUser = (function( users ){
			return function( user_uid ){
				return $q.when( users[ user_uid ] || (users[ user_uid ] = revokeUser( user_uid )));
			};
			function revokeUser( user_uid ){
				return $ApiHandler.get("/users/"+user_uid, {
					filters: "asarray,onlydata,onlyattrs"
				}).then(function( response ){
					return users[ user_uid ] = response.data[ 0 ];
				});
			}
		})( this.assets.artest_users );

		this._getArtestUserName = function( user_uid ){
			if (!this.assets.artest_users[ user_uid ]) self.getArtestUser( user_uid );
			return this.assets.artest_users[ user_uid ] && this.assets.artest_users[ user_uid ].$name || user_uid;
		};

		this._getArtestUserEmail = function( user_uid ){
			if (!this.assets.artest_users[ user_uid ]) self.getArtestUser( user_uid );
			return this.assets.artest_users[ user_uid ] && this.assets.artest_users[ user_uid ].$email || null;
		};

		/*********************/

		this._getArtestOeuvreImageUID = function( item ){
			if( typeof item == "string" ){
				item = item.toUpperCase();
				switch( item.substr( 0, 2)){
					case "B2": return item; // item ON Kuvan UID
					case "82": return "??"; // globaalin teoksen UID
					case "92": // Asiakkaan teoksen UID
						if( assets.clients_oeuvres[ item ]){
							if( assets.clients_oeuvres[ item ].with ){
								return assets.clients_oeuvres[ item ].with.oeuvre.img_uid;
							}
						} else {
							assets.clients_oeuvres[ item ] = self.getClientOeuvreSingles([ item ]);
						}
						return null;
				}
			}
		};

		/********************/

		this.uploadImage = function( file, filename ){
			return $q(function( resolve, reject ){
				try {

					if( file instanceof File ){

						filename = filename || file.name;
						var reader  = new FileReader();

						reader.onerror = function( err ){ reject( err ); };
						reader.onload = function(){
							self.uploadImage( reader.result, filename ).then(resolve).catch(reject);
						};
						reader.readAsDataURL(file);

					} else if( file instanceof Image ){

						return $ApiHandler.post( "/images", undefined, {
							"image.filename"      : filename || undefined,
							"_image_image.base64" : imageToBase64( file )
						})
						.then(function( response ){
							var img_uid = $ApiHandler.getParsedLocation( response ).href.substr( -16 );
							return $ApiHandler.get( "/images/"+img_uid, { filters: "asarray,onlydata,onlyattrs" });
						})
						.then(function( response ){
							resolve(response.data[0]);
						}).catch(reject);

					} else if( typeof file == "string" ){

						var src = file;
						var img = new Image();
						img.crossOrigin = 'Anonymous';
						img.onerror = function( err ){ reject( err ); };
						img.onload = function(){
							self.uploadImage( img, filename ).then(resolve).catch(reject);
						};
						img.src = src;
						if (img.complete || img.complete === undefined) {
							img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
							img.src = src;
						}

					} else throw new Error( "Invalid argument! :: Must get instanceof File/Image" );

				} catch( error ){
					reject( error );
				}
			}).catch(function( error ){
				console.error( "$userAssets.uploadImage :: Uploading failed!", error );
				throw error;
			});
		};

		this.imageToBase64 = imageToBase64;

		function imageToBase64( image, type, encoderOptions ) {
			var canvas    = document.createElement( 'canvas' );
			var ctx       = canvas.getContext( '2d' );

			canvas.height = image.naturalHeight;
			canvas.width  = image.naturalWidth;

			ctx.drawImage( image, 0, 0 );

			if (!type) try {

				var datas = {
					png: canvas.toDataURL( "image/png" ),
					jpg: canvas.toDataURL( "image/jpeg" )
				}, min_data, min_size;

				for (var key in datas) {
					if (!min_data || datas[key].length < min_size) {
						min_size = datas[key].length;
						min_data = datas[key];
					}
				}

				return min_data;

			} catch (error) {
				console.error( error );
			}

			return canvas.toDataURL( type, encoderOptions );
		}

	/****************************************************************************/

		function OeuvreProperty( prop ){
			angular.extend( this, prop );
			this.$i18n_key_title = "oeuvre property " + this.uid;
			this.title = this.i18n_title = this.$i18n_gen_title();

			this.$subs = { };
			this.$path = { };
		}
		OeuvreProperty.prototype.$i18n_gen_title = function() {
			return gettextCatalog.getStringIfExists( this.$i18n_key_title ) || this.title;
		};

	}])

	.service( "$tools", [ "$rootScope", "$userAssets", "$ApiHandler", function( $rootScope, $userAssets, $ApiHandler ){
		var self = this;

		this.download = {};

		this.download.base64 = function( base64data, mime, filename, anchor ) {
			var href;
			if (window.navigator.msSaveBlob) {
				var blob = Base64ToBlob( base64data, mime );
				window.navigator.msSaveBlob( blob, filename );
				return false;
			} else if (window.URL.createObjectURL) {
				var blob = Base64ToBlob( base64data, mime );
				href = window.URL.createObjectURL( blob );
			} else {
				href = "data:" + exporttype + ";base64," + base64data;
			}
		
			if (anchor) {
				anchor.href = href;
				anchor.download = filename;
				return true;
			} else {
				anchor = document.createElement( "a" );
				anchor.href = href;
				anchor.download = filename;
				anchor.click();
			}
		}

		/**
		 * Metodi jolla triggeröidä tiedoston lataaminen verkko-osoitteesta
		 */
		this.download.href = function downloadHref( href, filename, anchor ) {
			if (anchor) {
				anchor.href = href;
				anchor.download = filename || undefined;
				return true;
			} else {
				anchor = document.createElement( "a" );
				anchor.href = href;
				anchor.download = filename || undefined;
				anchor.click();
			}
		};

		/************************************************************************************************/

		this.downloadMatrice = function( type, arr, filename ){ };

		this.downloadMatrice.asXLS = function( arr, filename ) {
			var base64data = window.btoa(unescape(encodeURIComponent( MatriceToXLS( arr ))));

			self.download.base64( base64data, 'application/vnd.ms-excel', filename || 'export.xls' );

		};
	}])

	.service('currencies', [ "$userAssets", function( $userAssets ){
		return $userAssets.assets.currencies_data;
	}])

	.filter('dateToString', ["$rootScope", function( $rootScope ){
		var today = new Date();
		var isToday = (function( today ){
			return function( date ){ return _td( date ) == today };
		})( _td( today ));

		function _td( date ){ return date.getDate() + date.getMonth() + date.getFullYear(); }
		today.yyyy = today.getFullYear();

		return window.dateToString = $rootScope.dateToString = function dateToString( date ){
			if( date instanceof Date ){
				if( isToday( date )){
					return "klo. "+ date.getHours() +":"+ date.getMinutes();
				} else {
					var yyyy = date.getFullYear();
					if( yyyy == today.yyyy ){
						var dd = date.getDate();
						var mm = date.getMonth()+1;
						return (dd<10?"0":"") + dd + "." + (mm<10?"0":"") + mm + ".";
					} else {
						return date.toLocaleDateString();
					}
				}
			} else if( typeof date == "string" ){
				try {
					date = new Date(date);
				} catch( err ){
					console.error(err);
					return date;
				}
				return dateToString( date );
			}
			return date.toString();
		};
	}])

	.filter("artestUserName", ["$userAssets", function( $userAssets ){
		var user_uid_regexp = /^81[0-9a-fA-F]{14}$/;

		function getUid( obj ){
			return obj.user_uid || obj.owner_uid || obj.granted_by || obj.created_by || obj.uid;
		}
		function artestUserNameFilter( argv ){
			try {
				if( typeof argv == "string" && user_uid_regexp.test( argv )) return $userAssets._getArtestUserName( argv );
				if( typeof argv == "object" ) return $userAssets._getArtestUserName( getUid( argv ) );
			} catch( err ){
				console.error( err );
			}
			return argv;
		}
		artestUserNameFilter.$stateful = true;

		return artestUserNameFilter;
	}])

	.filter("artestUserEmail", ["$userAssets", function( $userAssets ){
		var user_uid_regexp = /^81[0-9a-fA-F]{14}$/;

		function getUid( obj ){
			return obj.user_uid || obj.owner_uid || obj.granted_by || obj.created_by || obj.uid;
		}
		function artestUserEmailFilter( argv ){
			try {
				if( typeof argv == "string" && user_uid_regexp.test( argv )) return $userAssets._getArtestUserEmail( argv );
				if( typeof argv == "object" ) return $userAssets._getArtestUserEmail( getUid( argv ) );
			} catch( err ){
				console.error( err );
			}
			return argv;
		}
		artestUserEmailFilter.$stateful = true;

		return artestUserEmailFilter;
	}])

	.filter("artestOeuvreImgUrl", ["$userAssets", function( $userAssets ){
		function func( argv ){
			try {
				return $userAssets._getArtestOeuvreImageUID( argv );
			} catch( err ){
				console.error( err );
			}
			return argv;
		}
		func.$stateful = true;

		return func;
	}])

	.filter("artestOeuvre", [ "$rootScope", "$userAssets", function( $rootScope, $userAssets ){

		var cache = { properties: {} };

		$rootScope.$on( "gettextLanguageChanged", function(){
			cache.properties = {};
		});

		var builderFns = {
			text: {
				"": function( oeuvre ){
					var t = (oeuvre.title || oeuvre.with.oeuvre.title);
					var c = (oeuvre.completed || oeuvre.with && oeuvre.with.oeuvre && oeuvre.with.oeuvre.completed);
		
					return t + (c ? ", " + c : "");
				},
				title: function( oeuvre ){
					return oeuvre.title || oeuvre.with.oeuvre.title;
				},
				properties: function( oeuvre ){
					var uids = oeuvre.methods_uids || oeuvre.with.oeuvre.methods_uids;
					var c_key = uids.join(", ");
					if (cache.properties[ c_key ]) return cache.properties[ c_key ];

					return cache.properties[ c_key ] = uids.map(function( v ){
						return (v = ArtestUserAssets.assets.oeuvre_properties[v]) && v.i18n_title;
					}).filter(function(v){ return v; }).join(", ");
				},
				size: function( oeuvre, unit ){
					unit = unit != "m" ? "cm" : "m";
					return buildSize( oeuvre, unit ).join( " x " ) + " " + unit;
				}
			},
			html: {
				size: function( oeuvre, unit ){
					unit = unit != "m" ? "cm" : "m";
					return buildSize( oeuvre, unit ).join( " &Cross; " ) + " " + unit;
				}
			}
		};

		/******************************************/

		return function( oeuvre, field ){
			try {
				if (field == "html") {
					return filter( oeuvre, "html", arguments[2], arguments[3], arguments[4] );
				} else {
					return filter( oeuvre, "text", arguments[1], arguments[2], arguments[3] );
				}
			} catch(e) {}
		};

		function filter( oeuvre, type, field, argv1, argv2 ) {
			field = field || "";
			
			if (builderFns[ type ] && builderFns[ type ][ field ]) {
				return builderFns[ type ][ field ]( oeuvre, argv1, argv2 );
			} else if (builderFns.text[ field ]) {
				return builderFns.text[ field ]( oeuvre, argv1, argv2 );
			}

			var val = oeuvre, path = field.split(".");
			for (var i in path) {
				if (!val) return;
				val = val[ path[i] ];
			}
			return val;
		}

		/******************************************/

		function buildSize( oeuvre, unit ){
			oeuvre = oeuvre.with && oeuvre.with.oeuvre || oeuvre;
			var vs = [ oeuvre.height, oeuvre.width ];
			if (oeuvre.depth) vs.push( oeuvre.depth );

			if (unit == "m") {
				vs = vs.map(function(v){ return v * 0.01; });
			} else {
				unit = "cm";
			}

			return vs.map(function(v){
				return v.toFixed(2);
			});
		}
	}])

	.filter('to_trusted', ['$sce', function($sce){
		return function(text) {
			return $sce.trustAsHtml(text);
		};
	}])

	.filter('as_currency', ['$sce', '$userAssets', function( $sce, $userAssets ){
		var aliasMap = { "EURO": "EUR" };
		var currencies = $userAssets.assets.currencies_data;

		return window.as_currency = function as_currency( value, currency_key, delimiter ) {
			var symbol = typeof currency_key == "string" && (currencies[ currency_key.toUpperCase() ] && currencies[ currency_key.toUpperCase() ].symbol) || currency_key || "";

			if (value == null) {
				value = "";
			} else {
				if (!isNaN( parseFloat( value ))) value = parseFloat( value );
				if (typeof value == "number") value = value.toFixed(2);
			}

			if (delimiter == null) {
				delimiter = " ";
			}

			return $sce.trustAsHtml( wrap( value + delimiter + symbol) );

			function wrap( str ) {
				return "<span style='white-space:nowrap'>" + str + "</span>";
			}
		}
	}])

	.filter( 'jsonObjectToHtml', [ '$sce', 'gettextCatalog', function( $sce, gettextCatalog ) {

		var blacklist = [ "updated_by", "updated_at", "created_by", "created_at", "uid", "client_uid" ];

		var i18n_map = {};

		return function( json, opts ) {

			opts = angular.extend({
				blacklist : blacklist,
				i18n_map  : i18n_map,
				i18n_fn   : function( key ) {

					var i18n_key = key;

					if (opts.i18n_map && opts.i18n_map[ key ]) {
						i18n_key = opts.i18n_map[ key ];
					}
						
					return gettextCatalog.getString( i18n_key );
				}
			}, opts || { });

			// Tarkistetaan onko kyseessä circular-json
			try {
				JSON.stringify( json );
			} catch (error) {
				console.error( error );
				return "";
			}

			/***********/

			var arr = objectToDataArr( json );

			var str = (opts.plain ? dataArrToPlain : dataArrToHtml)( arr );

			return str;

			/***********/
			
			function dataArrToHtml( arr ) {
				return $sce.trustAsHtml( arr.map(function( a ) {
					var key = opts.i18n_fn( a[1] );
					return "<span>" + ("  ".repeat( a[0] )) + "<b>" + key + ":</b> " + a[2] + "</span>";
				}).join( "\n" ));
			}

			function dataArrToPlain( arr ) {
				return arr.map(function( a ) {
					var key = opts.i18n_fn( a[1] );
					return "  ".repeat( a[0] ) + key + ": " + a[2];
				}).join( "\n" );
			}

				
			/***********/

			function objectToDataArr( obj, level ) {

				level = level || 0;

				var data = [];

				for (var key in obj) {

					var value = obj[ key ];

					if (!obj.hasOwnProperty( key )) continue;

					if (opts.blacklist.indexOf( key ) != -1) {
						continue;
					}

					if (key[0] == "$") {
						if (key[1] == "$") {
							continue;
						} else {
							continue;
						}
					}

					if (!angular.isArray( value )) {
						value = [ value ];
					}

					for (var i in value) {
						if (value[i] == null || value[i] == "") {
							// ----
						} else if (angular.isObject( value[i] )) {

							var arr;

							// Parsitaan mahdollisesti datamapin yhdestä tasosta lähtevä objekti
							try {
								if (_isDatamapLevel( value[i] )) {
									var _subs = {}; // pseudo-subs, jolla saadaan delegoitua otsikointi ja sisentäminen datamapSubsObjectToDataArr'lle
									_subs[ key ] = [ value[i] ];
									arr = datamapSubsObjectToDataArr( _subs, level );
								}

								if (arr && arr.length) {
									data.push.apply( data, arr );
								}
							} catch (error) { console.error( error );}

							if (!arr) {
								arr = objectToDataArr( value[i], level + 1 );

								if (arr.length) {
									data.push([ level, key, "" ]);
									data.push.apply( data, arr );
								}
							}
						} else {
							data.push([ level, key, value[i] ]);
						}


					}
				}

				return data;
			}

			function datamapSubsObjectToDataArr( subs, level ) {
				
				var data = [];

				for (var key in subs) {
					for (var i in subs[ key ]) {

						var value = subs[ key ][i];

						var subs_arr = datamapSubsObjectToDataArr( value.subs, level + 1 );

						if (value.value || subs_arr.length > 0) {
							data.push([ level, key, value.value || "" ]);
							data.push.apply( data, subs_arr );
						}
					}
				}

				return data;
			}

			function _isDatamapLevel( level ) {

				/** Tarkastetaan, ettei objektissa ole muita avaimia kuin "subs" tai "value" */

				var _skeys = Object.keys( level ), idx;

				if ((idx = _skeys.indexOf( "value" )) != -1) _skeys.splice( idx, 1 );
				if ((idx = _skeys.indexOf( "subs"  )) != -1) _skeys.splice( idx, 1 );

				if (_skeys.length != 0) return false; 
				
				if (level.subs) {

					// level.subs saa olla vain objekti { key1: [{ value:.., subs:{..} }], key2: [{ value:.., subs:{..} }] }
					if (!angular.isObject( level.subs )) return false;

					// Läpikäydään subs'n taulukot
					for (var key in level.subs) {
						for (var i in level.subs[key]) {
							if (!_isDatamapLevel( level.subs[key][i] )) return false;
						}
					}
				}

				return true;
			}
		}
	}])

	.filter('datamapStringify', [ '$sce', 'gettextCatalog', function( $sce, gettextCatalog ){
		if (!ADatamap.stringify) return function(){};

		var titleFn = function( key ){ return gettextCatalog.getStringIfExists( "ODM."+key ) || key; };
		var opts_plain = { titleFn: titleFn };
		var opts_html  = { titleFn: titleFn, 
			lineFn: function( line ){ return "<span style='white-space:pre'>"+ this.whitespace.repeat( line[0] ) +"<b>"+ line[1] +"</b>"+ this.delimiter + (line[2] == null ? this.nullValue : line[2]) +"</span>"; },
		};

		return function( data, format, thekey ) {
			var opts;

			if (thekey && typeof ADatamap.stringify[ thekey ] == "function") {
				try {
					return ADatamap.stringify[ thekey ]( data, format );
				} catch( err ) {
					console.error( err );
				}
			}

			switch( format || "" ) {
				case "html":
					opts = opts_html;
					break;
				default:
					console.warn( "Invalid argument: format=", format );
				case "":
				case "text":
					opts = opts_plain;
			}

			return ADatamap.stringify( data, opts );
		}
	}]);

	/*************************************/


	function generateFakeUID( oct ) {

		var uid = "00";

		if (oct != null && typeof oct == "string" && oct.length == 2) uid = oct;

		for (; uid.length < 16 ;)  uid += parseInt( Math.random() * 16 ).toString( 16 );

		return uid.toUpperCase();

	}
})();


function OeuvrePricing( arr_pricing ){

	Array.bind( true );

	this.push.apply( this, arr_pricing );
	this.length = 8;

	Object.defineProperty( this, "type", {
		get: function(){ return this[0]; },
		set: function(v){ this[0]=v; }
	});

	Object.defineProperty( this, "price_amount", {
		get: function(){ return this[1]; },
		set: function(v){ this[1]=v; }
	});

	Object.defineProperty( this, "price_vat_prs", {
		get: function(){ return this[2]; },
		set: function(v){ this[2]=v; }
	});

	Object.defineProperty( this, "description", {
		get: function(){ return this[3] || ""; },
		set: function(v){ this[3]=v; }
	});

	Object.defineProperty( this, "commission_prs", {
		get: function(){ return this[4]; },
		set: function(v){ this[4]=v; }
	});

	Object.defineProperty( this, "commission_from_gross", {
		get: function() { return this[5]; },
		set: function(v) { this[5]=!!v; }
	});

	if (OeuvrePricing.currencies) {
		var currs = OeuvrePricing.currencies;
		Object.defineProperty( this, "currency", {
			get: function(){ return this[6]; },
			set: function( curr ){ 
				if (OeuvrePricing.currencies.hasOwnProperty( v )) throw new ReferenceError( "Currency " + v + " is not defined for OeuvrePricing" );
				this[6] = curr;
			}
		});
	} else {
		Object.defineProperty( this, "currency", {
			get: function(){ return this[6]; },
			set: function(v){ this[6]=v; }
		});
	}

	Object.defineProperty( this, "commission_vat_prs", {
		get: function(){ return this[7]; },
		set: function(v){ this[7]=v; }
	});
}

OeuvrePricing.prototype = Object.create( Array.prototype );
OeuvrePricing.prototype.calcPriceVatAmount = function() {
	var prs = this.price_vat_prs || 0;
	var val = this.price_amount  || 0;

	return parseFloat(( val * prs / ( 100 + prs )).toFixed( 2 ));
};








/**
 * Builds a Blob-object from base64 data
 * @param {string} data The data in base64 format (eg. from window.btoa)
 * @param {string} [contentType=""] Mime of the content
 * @param {number} [sliceSize=512]
 * @returns {Object}
 */
function Base64ToBlob( data, contentType, sliceSize ) {
	// function taken from http://stackoverflow.com/a/16245768/2591950
	// author Jeremy Banks http://stackoverflow.com/users/1114/jeremy-banks
	contentType = contentType || '';
	sliceSize = sliceSize || 512;

	var byteCharacters = window.atob(data);
	var byteArrays = [];

	var offset;
	for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		var slice = byteCharacters.slice(offset, offset + sliceSize);

		var byteNumbers = new Array(slice.length);
		var i;
		for (i = 0; i < slice.length; i = i + 1) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		var byteArray = new window.Uint8Array(byteNumbers);

		byteArrays.push(byteArray);
	}

	return new window.Blob(byteArrays, {
		type: contentType
	});
}







/*
function test( matrice, opts ){
	var result = MatriceToCSV( test, opts );
	console.log(result);
	result = CSVToMatrice( result, opts );
	console.log(JSON.stringify(test));
	console.log(JSON.stringify(result));
}
*/


/**
 * Converts a CSV-like -string to 2D array
 * @link Based on https://stackoverflow.com/a/22850815
 * @param {string} string The CSV content
 * @param {Object} [options={}] Conversion options: separator, quoteChar, breakChar
 * @returns {string[][]}
 */
function CSVToMatrice( string, options ) {
	options = options || {};
	var separator = options.separator || ",";
	var quoteChar = options.quoteChar || '"';
	var breakChar = options.breakChar || "\n";

	var quoteRegexp = new RegExp( quoteChar );
	var breakRegexp = new RegExp( breakChar );

	var insideQuote = false, entries = [], entry = [];

	var rows = [];

	for (var i = 0; i < string.length; i++ ) {
		var character = string[i];

		if (breakRegexp.test( character )) {
			// Rivinvaihdon käsittely

			if (insideQuote) {
				// Merkkijonon sisällä otetaan rivinvaihto mukaan tekstiin
				entry.push( character )
			} else {
				// Muulloin lopetetaan rivi ja aloitetaan uusi
				entries.push( entry.join( '' ));
				rows.push( entries );

				entry   = [];
				entries = [];
			}
		} else if (character === quoteChar) {
			// Lainausmerkin käsittely
			
			if (insideQuote) {
				// Jos ollaa merkkijonon sisällä

				if (string[ i+1 ] == quoteChar) {
					// Jos  seuraava merkki on myös launausmerkki, tulkitaan escapetatuksi lainausmerkiksi

					entry.push( character );

					i++;

					continue;
				}
			}

			insideQuote = !insideQuote;



		} else {
			if (character === separator && !insideQuote) {                           
				entries.push( entry.join( '' ));
				entry   = [];
			} else {
				entry.push( character );                                         
			}                                                                
		}                                                                 
	}

	entries.push( entry.join( '' ));                                        
	rows.push( entries );

	return rows;                                                      
}

/**
 * Converts a 2D-array to CSV-like -string
 * @param {string[][]} rows The matrice
 * @param {Object} [options={}] Conversion options: separator, breakChar
 * @returns {string}
 */
function MatriceToCSV( rows, options ) {
	options = options || {};
	var separator = options.separator || ",";
	var breakChar = options.breakChar || "\n";
	var quoteChar = options.quoteChar || "\"";

	var escapeStrRegexp  = new RegExp( "("+ quoteChar +"|"+ breakChar +"|"+ separator +"|['\",:\\.\\;\\t\\n])", "g" );
	var escapeStrReplace = new RegExp( quoteChar, "g" );

	return rows.map(function( row ){
		return row.map(function( str ){
			str += "";
			if (str.match( escapeStrRegexp )) {
				str = str.replace( escapeStrReplace, quoteChar+quoteChar );
			}
			str = quoteChar + str + quoteChar;
			return str;
		}).join( separator );
	}).join( breakChar );
}

/**
 * Converts a 2D-array to XLS-string
 * @param {string[][]} rows The matrice
 * @returns {string}
 */
function MatriceToXLS( rows ) {
	var tableHTML = "<table>" + arr.map(function( row ){
		return "<tr>" + row.map(function( col ){
			return "<td>" + col + "</td>";
		}).join("") + "</tr>";
	}).join("") + "</table>";

	return '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Worksheet</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>' + tableHTML+ '</body></html>';
}
